import React from "react";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { CoinOptionItemProps } from "./types";
import NextImage from "@/src/components/NextImage";

export const CoinOptionItem: React.FC<CoinOptionItemProps> = ({
  data,
  selected = false,
  selectedIconName,
  onClick,
}) => {
  return (
    <button
      aria-label="Coin Option Item"
      data-openreplay-label="Coin Option Item Button"
      id="btn-coin-option-item"
      type="button"
      role="option"
      aria-selected={selected}
      className={cn(
        "flex h-10 w-full items-center gap-2 rounded-[6px] px-3 py-2 text-left transition-colors hover:bg-background_white_overlay5",
      )}
      onClick={onClick}
    >
      <NextImage
        src={data.coinIcon}
        alt={data.coin}
        width={20}
        height={20}
        className="w-5 h-5 rounded-full flex-shrink-0"
      />
      <div className="flex flex-col min-w-0 flex-1">
        <span className="body_medium_m text-content_primary truncate">
          {data.coin}
        </span>
      </div>
      {selected && (
        <OspIcons
          name={selectedIconName ?? "check"}
          size={12}
          color={ospThemes.colors.content_brand_primary}
          className="leading-none"
        />
      )}
    </button>
  );
};
